import { UserLock, Monitor, LayoutDashboard } from "lucide-react";
import { Children } from "react";

// Navigation items with roles
export const navItems = [
  {
    text: "Dashboard",
    link: "/dashboard",
    icon: LayoutDashboard,
    roles: ["admin", "user"],
  },
  {
    text: "Users",
    link: "/dashboard/manage-users/admin",
    icon: UserLock,
    roles: ["admin"],
    children: [
      {
        text: "Admins",
        link: "/dashboard/manage-users/admin",
        icon: UserLock,
        roles: ["admin"],
      },
      {
        text: "Guests",
        link: "/dashboard/manage-users/user",
        icon: UserLock,
        roles: ["admin"],
      },
    ],
  },
  {
    text: "Machines",
    link: "/dashboard/machines",
    icon: Monitor,
    roles: ["admin", "user"],
  },
];
